/**
 * Entry-point del builder no-code de Veo. Es un bundle SEPARADO del SDK de
 * producción: el dashboard lo inyecta en la app del cliente SOLO al entrar
 * en modo builder (elegir el ancla de una guía, previsualizarla). Así el
 * bundle que cargan los usuarios finales no paga el costo del inspector.
 *
 * Dos formas de consumo:
 *   - Bundler:  `import { startElementPicker } from '@veo/sdk/builder'`
 *   - Script-tag (IIFE): expone `window.veoBuilder` con `startElementPicker`,
 *     `previewGuide`, etc. (carga `dist/veo-builder.js`).
 */
import { initBuilderMode } from './plugins/builder';

export type {
  BuilderCommand,
  BuilderEvent,
  BuilderModeHandle,
  BuilderSession,
  BuilderSessionOptions,
  ElementPickerHandle,
  ElementPickerOptions,
  PickedElement,
} from './plugins/builder';
export {
  createBuilderSession,
  initBuilderMode,
  startElementPicker,
  stopElementPicker,
} from './plugins/builder';
export type { PreviewGuideInput, PreviewHandle, PreviewResult } from './plugins/guides';
export { closeGuidePreview, previewGuide } from './plugins/guides';

// Auto-conexión en script-tag (IIFE): si la URL trae `?veoBuilder=<token>`,
// la app del cliente se enlaza con el dashboard apenas carga veo-builder.js.
// Es no-op si no hay token (uso normal o import desde el dashboard).
initBuilderMode();
